import * as React from 'react'
import Box from '@mui/material/Box'
import { AddServiceProductButton } from '../AddServiceProductButton'
import { SaveServicesForLaterButton } from '../SaveServicesForLaterButton/SaveServicesForLaterButton'
import { SummaryCard } from '../styled/SummaryCard.styled'
import { Title } from './styled'
import { SummaryContents } from './SummaryContents'
import { useTheme } from '@mui/material/styles'
import { useData } from './hooks'
import { ENTITY_TYPES } from '@sales-center/common'

type Props = {
  addServiceButtonClick: () => void
  disabled: boolean
  entityType: ENTITY_TYPES
  loading: boolean
  saveServicesForLaterClick: () => void
  tabletView: boolean
  totalServicesCount?: number
  isClosedEntity: boolean
  createNewOpp?: boolean
}

export function ServiceProductsSummary(props: Props) {
  const {
    addServiceButtonClick,
    disabled,
    entityType,
    loading,
    saveServicesForLaterClick,
    tabletView,
    totalServicesCount,
    isClosedEntity,
    createNewOpp = false,
  } = props
  const theme = useTheme()
  const { disabledTooltipText, saveForLaterButtonDisabled } = useData({
    entityType,
    isClosedEntity,
    totalServicesCount,
  })

  return (
    <>
      {tabletView && <Title>Services / Products Summary</Title>}
      <SummaryCard>
        {!tabletView && <Title>Services / Products Summary</Title>}
        <SummaryContents />
        <AddServiceProductButton
          addServiceButtonClick={addServiceButtonClick}
          buttonFullWidth
          buttonVariant="contained"
          disabled={disabled}
          loading={loading}
        />
        {!createNewOpp && (
          <Box sx={{ mt: theme.spacing(1) }}>
            <SaveServicesForLaterButton
              disabled={saveForLaterButtonDisabled || disabled}
              loading={loading}
              disabledTooltipText={disabledTooltipText}
              onClick={saveServicesForLaterClick}
            />
          </Box>
        )}
      </SummaryCard>
    </>
  )
}
